import Header from "./components/Header";
import Nav from "./components/Nav";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Marketing from "./components/Marketing";
import Proyectos from "./components/Proyectos";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
    <Header />
    <Nav />
    <About />
    <Portfolio />
    <Marketing />
    <Proyectos />
    <Contact />
    <Footer />
    </>
  );
}

export default App;
